angular.module("UI8.components").component("ai", {
  template: `
    <div class="page page--dna">
      <div class="page__background">
        <img src="https://images.ui8.net/redesign/hero-home.jpg" alt="Hero" />
      </div>
      <div class="page__container container">

        <div class="page__hero">
          <h1 class="page__title">Design intelligence built for AI</h1>
          <div class="page__description">
            Introducing Design DNA. Feed your tools real design knowledge from real-world curated products.
          </div>
          <a class="btn" href="/products/all-access-pass">Unlock with All Access</a>
        </div>

        <div class="dna">

          <div class="dna__hero">
            <div class="dna__section">
              <div class="dna__preview">
                <figure>
                  <img srcset="/img/dna/without-design-dna.avif 1x, /img/dna/without-design-dna@2x.avif 2x" src="/img/dna/without-design-dna.avif" alt="Without Design DNA" />
                </figure>
              </div>
              <div class="btn btn--stroke">
                <svg>
                  <path d="M10 6L6 10M10 10L6 6M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="#787878" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                without Design DNA
              </div>
            </div>
            <div class="dna__section">
              <div class="dna__preview">
                <figure>
                  <img srcset="/img/dna/with-design-dna.avif 1x, /img/dna/with-design-dna@2x.avif 2x" src="/img/dna/with-design-dna.avif" alt="With Design DNA" />
                </figure>
                <figure>
                  <img srcset="/img/dna/with-design-dna-mobile.avif 1x, /img/dna/with-design-dna-mobile@2x.avif 2x" src="/img/dna/with-design-dna-mobile.avif" alt="With Design DNA Mobile" />
                </figure>
              </div>
              <div class="btn btn--dna">
                <span class="dna-icon">with Design DNA</span>
              </div>
            </div>
            <div class="dna__message">One prompt. Worlds apart.</div>
          </div>

          <div class="dna__head">
            <h2 class="dna__title">The only difference? <br>Design DNA injected into the prompt</h2>
            <div class="dna__description">Same AI tool, same prompts. This is what UI8's library of curated design systems makes possible in just a few clicks.</div>
          </div>

          <ul class="dna__list">
            <li class="dna__item">
              <div class="dna__item-preview">
                <figure>
                  <img srcset="/img/dna/use-any-product.avif 1x, /img/dna/use-any-product@2x.avif 2x" src="/img/dna/use-any-product.avif" alt="Use any product marked as AI-ready" />
                </figure>
              </div>
              <div class="dna__item-title">
                <span>1</span>
                <span></span>
                <span>Use any product marked as AI-ready</span>
              </div>
            </li>
            <li class="dna__item">
              <div class="dna__item-preview">
                <figure>
                  <img srcset="/img/dna/click-copy-dna.avif 1x, /img/dna/click-copy-dna@2x.avif 2x" src="/img/dna/click-copy-dna.avif" alt="Click 'Copy Design DNA'" />
                </figure>
              </div>
              <div class="dna__item-title">
                <span>2</span>
                <span></span>
                <span>Click "Copy Design DNA"</span>
              </div>
            </li>
            <li class="dna__item">
              <div class="dna__item-preview">
                <figure>
                  <img srcset="/img/dna/paste-into-ai-tool.avif 1x, /img/dna/paste-into-ai-tool@2x.avif 2x" src="/img/dna/paste-into-ai-tool.avif" alt="Paste into your AI tool" />
                </figure>
              </div>
              <div class="dna__item-title">
                <span>3</span>
                <span></span>
                <span>Paste into your AI tool</span>
              </div>
            </li>
          </ul>

          <div class="dna__mcp">Want to go deeper? Download Figma files and connect them directly through the <a href="https://help.figma.com/hc/en-us/articles/32132100833559-Guide-to-the-Figma-MCP-server" target="_blank">Figma MCP server</a>.</div>

          <div class="catalog catalog--dna" ng-if="$ctrl.dnaProducts && $ctrl.dnaProducts.products && $ctrl.dnaProducts.products.length">
            <product-card
              ng-repeat="product in $ctrl.dnaProducts.products track by product._id"
              product="product">
            </product-card>
          </div>
          
          <form class="dna__form" style="background-image: url(/img/dna/bg-dna-form.avif)" ng-submit="$ctrl.joinWaitlist()">
            <h3 class="dna__form-title">We're just warming up</h3>
            <div class="dna__form-description">New AI features are shipping fast, get notified when the next one drops.</div>
            <div class="field" ng-if="!$ctrl.success">
              <input class="field__input" type="email" name="email" ng-model="$ctrl.email" placeholder="designer@example.com" ng-class="{'error': $ctrl.emailError || $ctrl.duplicateError}" ng-change="$ctrl.emailError = false; $ctrl.duplicateError = false">
              <button class="field__action" type="submit" ng-disabled="$ctrl.pending">
                <svg width="24" height="24">
                  <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.613 4.81l.094.083 4.4 4.4c.028.028.055.059.08.09l-.08-.09a1.01 1.01 0 0 1 .097.112 1.03 1.03 0 0 1 .05.075.87.87 0 0 1 .021.037c.011.02.021.04.031.061a.96.96 0 0 1 .022.052.99.99 0 0 1 .022.06 1.07 1.07 0 0 1 .014.046c.006.022.011.043.016.065s.007.035.009.052.005.041.007.061a1.05 1.05 0 0 1 .003.055c0 .01.001.021.001.032l-.001.033c-.001.017-.002.035-.003.052L17.4 12a1.01 1.01 0 0 1-.011.149c-.003.017-.006.034-.009.052a.94.94 0 0 1-.015.065 1.11 1.11 0 0 1-.014.046.95.95 0 0 1-.021.059c-.007.018-.015.035-.023.052a1.02 1.02 0 0 1-.031.061.88.88 0 0 1-.021.036c-.016.026-.032.05-.05.074a.7.7 0 0 1-.013.018l-.083.094-4.4 4.4a1 1 0 0 1-1.497-1.32l.083-.094L13.985 13H7.6a1 1 0 0 1-.117-1.993L7.6 11h6.385l-2.692-2.693a1 1 0 0 1 1.32-1.497z"></path>
                </svg>
              </button>
              <div class="field__error" ng-show="$ctrl.emailError">Please enter a valid email address.</div>
              <div class="field__error" ng-show="$ctrl.duplicateError">This email is already on the list.</div>
            </div>
            <div class="dna__form-success" ng-if="$ctrl.success">You're on the list. We'll let you know when it's ready.</div>
          </form>

        </div>

        <div class="docs">
          <div class="docs__title">FAQ</div>
          <ul class="docs__list">
            <li class="docs__item">
              <div class="docs__question">What is Design DNA?</div>
              <div class="docs__answer">Design DNA is a structured file containing a product's design system — colors, typography, spacing, and component patterns formatted for AI coding tools. Paste it into your AI tool and everything it generates will follow a professional design system instead of generic defaults.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">How do I use Design DNA with AI tools?</div>
              <div class="docs__answer">Click the "Design DNA" button on any supported product page and copy the DNA. The modal includes setup instructions tailored to the AI tool you're using.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Which AI coding tools work with Design DNA?</div>
              <div class="docs__answer">Design DNA works with any AI tool that accepts text context, including Cursor, Claude, v0, Bolt, Windsurf, and GitHub Copilot.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Do all products include Design DNA?</div>
              <div class="docs__answer">Not yet. Products with Design DNA are marked with an "AI-Ready" badge. We're adding DNA to more products every week.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Does copying Design DNA count toward my daily download limit?</div>
              <div class="docs__answer">No. Copying Design DNA is unlimited. Download limits only apply to downloading the original product files.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Can I get Design DNA without an All Access Pass?</div>
              <div class="docs__answer">Yes. Purchasing any individual product that includes Design DNA gives you access to everything: source files and Design DNA included.</div>
            </li>
          </ul>
          <div class="docs__hint">Couldn't find what you were looking for? <a onclick="window.$chatwoot && window.$chatwoot.toggle('open')">Contact us</a></div>
        </div>

      </div>
    </div>
  `,

  bindings: {
    dnaProducts: "<",
  },

  controller: [
    "$http",
    function ($http) {
      var ctrl = this;

      ctrl.email = "";
      ctrl.pending = false;
      ctrl.success = false;
      ctrl.emailError = false;
      ctrl.duplicateError = false;

      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      ctrl.joinWaitlist = function () {
        if (ctrl.pending) return;
        if (!ctrl.email || !emailRe.test(ctrl.email)) {
          ctrl.emailError = true;
          return;
        }
        ctrl.pending = true;
        $http
          .post("/api/newsletter/loops", { email: ctrl.email })
          .then(function (res) {
            ctrl.pending = false;
            if (res.data.success) {
              ctrl.success = true;
            } else if (
              res.data.message &&
              res.data.message.toLowerCase().indexOf("already") !== -1
            ) {
              ctrl.duplicateError = true;
            } else {
              ctrl.success = true;
            }
          })
          .catch(function () {
            ctrl.success = true;
            ctrl.pending = false;
          });
      };

      ctrl.$onInit = function () {
        // Scroll to top
        window.scroll(0, 0);

        const docsItem = $(".docs__item");

        docsItem
          .on("click", function () {
            const _this = $(this);
            if (_this.hasClass("active")) {
              _this.removeClass("active");
              _this.find(".docs__answer").slideUp();
            } else {
              docsItem.removeClass("active");
              docsItem.find(".docs__answer").slideUp();
              _this.addClass("active");
              _this.find(".docs__answer").slideDown();
            }
          })
          .first()
          .trigger("click");
      };
    },
  ],
});
